import { useState } from "react";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch("/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || "Login failed.");
        return;
      }

      onLogin(data.token, data.email);
    } catch {
      setError("Could not reach server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "#f0f2f5" }}>

      {/* Top bar */}
      <div className="flex items-center justify-between px-6 py-3" style={{ background: "#fff", borderBottom: "1px solid #e5e7eb" }}>
        <img
          src="https://dc3control.com/wp-content/uploads/2024/07/New-Logo-for-Mariya-1-1024x492.png"
          alt="DC3 Control"
          className="h-8 object-contain"
        />
        <div className="flex items-center gap-2">
          <a
            href="/"
            className="text-sm font-medium px-4 py-1.5 rounded transition"
            style={{ color: "#15aece", border: "1px solid #15aece" }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "#15aece"; e.currentTarget.style.color = "#fff"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#15aece"; }}
          >
            ← Docs
          </a>
          <a
            href="https://dc3control.net/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-medium px-4 py-1.5 rounded text-white transition"
            style={{ background: "#15aece" }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.85")}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
          >
            Portal →
          </a>
        </div>
      </div>

      {/* Card */}
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="bg-white rounded-lg w-full max-w-sm" style={{ boxShadow: "0 4px 24px rgba(0,0,0,0.10)", padding: "2.5rem" }}>

          <h1 className="text-xl font-bold text-center mb-1" style={{ color: "#212121" }}>DC3 Admin Portal</h1>
          <p className="text-sm text-center mb-7" style={{ color: "#9ca3af" }}>Sign in to view usage &amp; audit logs</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wide" style={{ color: "#6b7280" }}>Email</label>
              <input
                type="email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="w-full border border-gray-200 rounded-md px-3 py-2.5 text-sm focus:outline-none transition"
                onFocus={(e) => (e.target.style.borderColor = "#15aece")}
                onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                placeholder="you@example.com"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wide" style={{ color: "#6b7280" }}>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full border border-gray-200 rounded-md px-3 py-2.5 text-sm focus:outline-none transition"
                onFocus={(e) => (e.target.style.borderColor = "#15aece")}
                onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                placeholder="••••••••"
              />
            </div>

            {error && (
              <p className="text-xs text-red-500 bg-red-50 border border-red-100 rounded px-3 py-2">{error}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full text-white rounded-md py-2.5 text-sm font-semibold transition disabled:opacity-50"
              style={{ background: "#15aece", marginTop: "0.25rem" }}
              onMouseEnter={(e) => !loading && (e.currentTarget.style.opacity = "0.88")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
            >
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>
        </div>
      </div>

    </div>
  );
}
